import { FirebaseService } from './../../services/firebase.service';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BrdsqlService } from '../../services/brdsql.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-seasone6465',
  templateUrl: './seasone6465.component.html',
  styleUrls: ['./seasone6465.component.css']
})
export class Seasone6465Component implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  AddTruckdata: UntypedFormGroup;
  EditTruckdata: UntypedFormGroup;
  AddKeepdata: UntypedFormGroup;
  EditKeepdata: UntypedFormGroup;
  submitted = false;
  zone: any;
  setEdit = false;
  constructor(private auth: Authenticationservice, private firebase: FirebaseService, private spinner: NgxSpinnerService, private brdservice: BrdsqlService, private http: HttpClient) {
    let lebdata: any = this.auth.Authention();
    this.zone = lebdata.zonedata;
    if (lebdata.userlevel == '13') { this.setEdit = true };
    console.log('supzone:', brdservice.supzoneAll);
    this.zonecode = brdservice.supzoneAll;

    this.AddTruckdata = new UntypedFormGroup({
      trust: new UntypedFormControl(),
      onetruckboardno: new UntypedFormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(9)]),
      twocodetruck: new UntypedFormControl('', [Validators.required]),
      twopcodetruck: new UntypedFormControl('', [Validators.required]),
      threegroupcode: new UntypedFormControl('', [Validators.required]),
      fourzonecode: new UntypedFormControl('0', [Validators.required]),
      fivetrucktype: new UntypedFormControl('', [Validators.required]),
      sixsmartphone: new UntypedFormControl('', [Validators.required]),
      sevengps: new UntypedFormControl('', [Validators.required]),
      selectthreegroupcode: new UntypedFormControl(),
      carduid: new UntypedFormControl(),
    });

    this.AddKeepdata = new UntypedFormGroup({
      trust: new UntypedFormControl(),
      onefmcode: new UntypedFormControl('', [Validators.required]),
      onefmname: new UntypedFormControl('', [Validators.required]),
      twogroupcode: new UntypedFormControl('', [Validators.required]),
      threezonecode: new UntypedFormControl('', [Validators.required]),
      fourdrivername: new UntypedFormControl('', [Validators.required]),
      fivedriverphone: new UntypedFormControl('', [Validators.required]),
      selecttwogroupcode: new UntypedFormControl(),
    });

    this.EditKeepdata = new UntypedFormGroup({
      trust: new UntypedFormControl(),
      oneeditfmcode: new UntypedFormControl('', [Validators.required]),
      oneeditfmname: new UntypedFormControl('', [Validators.required]),
      twoeditgroupcode: new UntypedFormControl('', [Validators.required]),
      threeeditzonecode: new UntypedFormControl('', [Validators.required]),
      foureditdrivername: new UntypedFormControl('', [Validators.required]),
      fiveeditdriverphone: new UntypedFormControl('', [Validators.required]),
    });
  }

  get form(): { [key: string]: AbstractControl } {
    return this.AddTruckdata.controls;
  }
  get editform(): { [key: string]: AbstractControl } {
    return this.EditTruckdata.controls;
  }

  get keepform(): { [key: string]: AbstractControl } {
    return this.AddKeepdata.controls;
  }
  @ViewChild('truckTable', { static: false }) truckTable: any;
  @ViewChild('keepTable', { static: false }) keepTable: any;

  ngOnInit(): void {
    // this.LoadCancletrucklist();
    //this.LoadgroupCut();
    //this.LoadTruckdata();
    //this.LoadZone();
    //this.LoadAllKeep();
  }

  cid = 1;
  lastkey: any[];
  lastcode: any;
  Autorunwithoutourfarmer() {
    // this.firebase.ADDTruckDriverout();
    this.spinner.show();
    this.firebase.ShowTruckDriverout().then((truckcode: any) => {
      this.lastkey = truckcode;
      this.lastcode = (this.lastkey.filter((el: any) => el.code != null || el.code != undefined)).slice(-1)[0];
      this.AddTruckdata.get('twocodetruck').setValue(parseInt(this.lastcode.code) + 1);
      this.spinner.hide();
    });

    // console.log(data);
  }

  applyFilter(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.Dataalltruck.filter = filterValue2.trim().toLowerCase();;
    if (this.Dataalltruck.paginator) {
      this.Dataalltruck.paginator.firstPage();
    }
  }

  applyFilter2(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.truckdata.filter = filterValue2.trim().toLowerCase();;
    if (this.truckdata.paginator) {
      this.truckdata.paginator.firstPage();
    }
  }
  listtrucktype = [
    { "type": "B", "typename": "รถสิบล้อ" },
    { "type": "B1", "typename": "รถพ่วง(แม่)" },
    { "type": "B2", "typename": "รถพ่วง(ลูก)" },
    { "type": "S", "typename": "รถหกล้อ" },
    { "type": "S1", "typename": "รถหกล้อหัวยาว" },
    { "type": "T", "typename": "รถโยน" }
  ]

  tabcolor = 1;
  addtruck = false;
  showalltruck = true;
  addkeep = false;
  showallkeep = true;

  person1: any;
  CheckFarmer1() {
    let fmcode = this.AddTruckdata.get('twocodetruck').value;

    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_farmer_basic_w?fmcode=" + fmcode;
    let url = `${this.h_url}dbcps/select_s_f_w_0?s=*&f=[cps6263].[dbo].[v_farmer_basic]&w=fmcode='${fmcode}'`;
    axios.get(url)
      .then(res => {
        let data = res.data
        if (data.length > 0) {
          this.person1 = data[0].fmname;
          this.AddTruckdata.get('twopcodetruck').setValue((this.person1).toString());
        }
        else {
          this.AddTruckdata.get('twopcodetruck').setValue('');
        }
      }
      ).catch(error => {
        console.log(error);
      })
  }

  // 
  displayedColumns = ['truckcode', 'fmcode', 'fullname', 'truckboard', 'trucktype', 'groupcode', 'carduid', 'action'];
  displayedColumns2 = ['truckcode', 'SUPZONE', 'fmcode', 'fullname', 'truckboard', 'trucktype', 'groupcode', 'carduid', 'action'];

  @ViewChild('tablecancletruck', { static: false }) cancletruckTable: any;
  // โหลดข้อมูลรถบรรทุก
  truckdata: any;
  alltruck: any;
  Dataalltruck: any;
  @ViewChild('zonetruck', { static: false }) zonetruckTable: any;
  h_url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/'; // เปลี่ยนเป็น URL ของ Cloud Function

  cancletrucklist: any;
  LoadTruckdata() {
    this.alltruck = [];
    this.cancletrucklist = [];
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_v_Truck_w?TRUCK_TYPE=%27X%27";
    let url = `${this.h_url}dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_Truck_ck]&w=1=1`;
    axios.get(url)
      .then(res => {
        let data = res.data;
        //data.sort(function (b, a) { return b.TRUCK_NO - a.TRUCK_NO });
        data = data.map((item: any) => {
          return { ...item, to_edit: false };
        });
        console.log('Truck:', data);
        if (data.length > 0) {
          this.alltruck = data.filter(el => el.TRUCK_TYPE != 'X');
          this.cancletrucklist = data.filter(el => el.TRUCK_TYPE == 'X');
          //this.setDataTeble(2);
        }
      }).catch(err => { throw (err) })
  }

  settap = 1;

  ngAfterViewInit(): void {
    this.loadDataTable1();
    this.loadDataTable2();
  }
  loading: boolean[] = [false, false, false, false];
  table1: any;
  loadDataTable1(): void {
    let url = `${this.h_url}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    let dataTable = {
      table: `[dbQBRD].[dbo].[v_Truck_ck]`
      , col_like: 'FMCODE_B1,FMname,REGTRUCK,carduid,GROUPCODE'
      , where: '1=1' // เงื่อนไขเพิ่มเติมถ้าต้องการ
    }
    if (this.table1) {
      this.table1.destroy(); // ทำลายตารางเก่า ถ้ามี
    }
    this.table1 = $('#datatable1').DataTable({
      processing: true,
      serverSide: true,
      paging: true, // ✅ เปิดใช้งาน Pagination
      searching: true, // ✅ เปิดใช้งาน Search
      ordering: true, // ✅ เปิดใช้งาน Sorting
      ajax: (data, callback) => {
        const params = {
          table: dataTable.table,
          col_like: dataTable.col_like,
          where: dataTable.where,
          start: (data as any).start,
          length: (data as any).length,
          search: (data as any).search.value.trim(),
          orderColumn: (data as any).columns[(data as any).order[0].column].data,
          orderDir: (data as any).order[0].dir,
          draw: (data as any).draw
        };
        this.loading[1] = true;
        this.http.get(url, { params }).subscribe((resp: any) => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
          this.loading[1] = false; // ซ่อนตัวโหลดหลังจากโหลดเสร็จ
        }, () => {
          this.loading[1] = false; // ซ่อนตัวโหลดในกรณีเกิดข้อผิดพลาด
        });
      },
      columns: [
        { data: 'TRUCK_NO', title: 'รหัสรถ' },
        { data: 'SUPZONE', title: 'โซน' },
        { data: 'OWNCODE', title: 'โควตา' },
        { data: 'FMname', title: 'ชื่อ', className: 'text-left' },
        { data: 'REGTRUCK', title: 'ทะเบียนรถ', className: 'text-left' },
        { data: 'TRUCK_TYPE', title: 'type', },
        { data: 'TRUCK_TYPENAME', title: 'ประเภทรถ', },
        { data: 'GROUPCODE', title: 'กลุ่ม', },
        { data: 'carduid', title: 'รหัสบัตร', },
        {
          data: 'Lastupdate', title: 'Lastupdate', className: 'text-left',
          render: (data: any) => { return this.date2th(data) }
        },
      ]
    });
  }

  table2: any;
  loadDataTable2(): void {
    let url = `${this.h_url}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    let dataTable = {
      table: `[dbQBRD].[dbo].[v_Car_keep_data]`
      , col_like: 'FMCODE_B1,Fmname,Groupcode'
      , where: '1=1' // เงื่อนไขเพิ่มเติมถ้าต้องการ
    }
    if (this.table2) {
      this.table2.destroy(); // ทำลายตารางเก่า ถ้ามี
    }
    this.table2 = $('#datatable2').DataTable({
      processing: true,
      serverSide: true,
      paging: true, // ✅ เปิดใช้งาน Pagination
      searching: true, // ✅ เปิดใช้งาน Search
      ordering: true, // ✅ เปิดใช้งาน Sorting
      ajax: (data, callback) => {
        const params = {
          table: dataTable.table,
          col_like: dataTable.col_like,
          where: dataTable.where,
          start: (data as any).start,
          length: (data as any).length,
          search: (data as any).search.value.trim(),
          orderColumn: (data as any).columns[(data as any).order[0].column].data,
          orderDir: (data as any).order[0].dir,
          draw: (data as any).draw
        };
        this.loading[2] = true; // แสดงตัวโหลดก่อนเรียก API
        this.http.get(url, { params }).subscribe((resp: any) => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
          this.loading[2] = false; // ซ่อนตัวโหลดหลังจากโหลดเสร็จ
        }, () => {
          this.loading[2] = false; // ซ่อนตัวโหลดในกรณีเกิดข้อผิดพลาด
        });
      },
      columns: [
        { data: 'Keep_no', title: 'รหัสรถ' },
        { data: 'Supzone', title: 'โซน' },
        { data: 'Owncode_keep', title: 'โควตา' },
        { data: 'Fmname', title: 'ชื่อ', className: 'text-left' },
        { data: 'Groupcode', title: 'กลุ่ม', },
        { data: 'name_keeper', title: 'คนขับรถคีบ', },
        { data: 'carduid', title: 'รหัสบัตร', }, {
          data: 'lastupdate', title: 'lastupdate', className: 'text-left',
          render: (data: any) => { return this.date2th(data) }
        },
      ]
    });
  }

  date2th(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  // ข้อมูลรถคีบทั้งหมด
  keepcarall: any[] = [];
  keepcarS: any[] = [];
  LoadAllKeep() {
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_Car_keep_w?t=1";
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_Car_keep_data]&w=1=1`;
    axios.get(url)
      .then(res => {
        this.keepcarall = (res.data);
        this.setDatakeep(1);
      }).catch(err => { throw (err) })
  }

  setKtap = 1;
  newtableK: any;
  Dataallkeep: any[] = [];
  setDatakeep(id: number) {
    this.setKtap = id
    let datakeep;
    if (id == 1) {//all
      datakeep = this.keepcarall
    }
    else if (id == 2) {//โซน
      datakeep = (this.keepcarall).filter(el => el.Supzone == this.zone)
    }
    if (this.newtableK != undefined || this.newtableK != null) this.newtableK.destroy();
    if (datakeep.length > 0) {
      this.Dataallkeep = datakeep;
      setTimeout(() => {
        this.newtableK = $(this.keepTable.nativeElement).DataTable({ order: [[0, 'desc']] });
      }, 10);
    }
    console.log('data', id, datakeep.length);
  }

  // โหลดกลุ่มตัด 
  groupcutdata: any;
  LoadgroupCut() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/v_groupCode_HM_w?category=%27H%27";
    axios.get(url)
      .then(res => {
        this.groupcutdata = (res.data.recordset);
      }).catch(err => { throw (err) })
  }

  // โหลดข้อมูล zone
  zonecode: any;
  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
      }).catch(err => { throw (err) })
  }
  // บันทึกข้อมูลรถบรรทุกใหม่
  SaveNewTruck() {
    this.submitted = true;
    let setdata;
    setdata = this.AddTruckdata.value;
    console.log(setdata);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/insert_truckBRR?GROUPCODE=%27" + setdata.threegroupcode + "%27"
      + "&OWNCODE=%27" + setdata.twocodetruck + "%27"
      + "&FMNAME=%27" + setdata.twopcodetruck + "%27"
      + "&TRUCK_TYPE=%27" + setdata.fivetrucktype + "%27"
      + "&REGTRUCK=%27" + setdata.onetruckboardno.trim() + "%27"
      + "&Lastupdate=getdate()" + "&dataOK=1"
      + "&smartPhone=" + setdata.sixsmartphone
      + "&gps=" + setdata.sevengps
      + "&SUPZONE=%27" + setdata.fourzonecode + "%27"
      + "&carduid=%27" + setdata.carduid + "%27"
      + "&date_add_carduid=getdate()"
      ;
    if (setdata.onetruckboardno == '' || setdata.onetruckboardno == undefined) { alert("กรุณาระบุ ทะเบียนรถ"); }
    else if (setdata.twopcodetruck == '' || setdata.twopcodetruck == undefined) { alert("กรุณาระบุ ชื่อชาวไร่"); }
    else if (setdata.twocodetruck == '' || setdata.twocodetruck == undefined) { alert("กรุณาระบุ โควตาชาวไร่"); }
    else if (setdata.threegroupcode == '' || setdata.threegroupcode == undefined) { alert("กรุณาระบุ กลุ่ม"); }
    else if (setdata.fourzonecode == '' || setdata.fourzonecode == undefined) { alert("กรุณาระบุ โซน"); }
    else if (setdata.fivetrucktype == '' || setdata.fivetrucktype == undefined) { alert("กรุณาระบุ ประเภทรถ"); }
    else if (setdata.sixsmartphone == '' || setdata.sixsmartphone == undefined) { alert("กรุณาเลือกสมาร์ทโฟน"); }
    else if (setdata.sevengps == '' || setdata.sevengps == undefined) { alert("กรุณาเลือก GPS"); }
    else {
      if (this.checkdata == 1) { alert("ไม่สามารถบันทึกได้เนื่องจะทะเบียนซ้ำ") }
      else {
        axios.post(url).then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("บันทึกรายการเรียบร้อย ^^");
            $("input[type=text]").val('');
            this.LoadTruckdata();
            //this.AddTruckdata.reset();
            this.enable = true;
          }
          else {
            alert(" ! !ล้มเหลว ไม่สามารถบันทึกรายการได้! !");
          }
        }).catch(err => { throw (err) });
      }
    }

    if (this.lastcode.code != undefined || this.lastcode.code != null || this.lastcode.code != undefined) {
      this.firebase.ADDTruckDriverout(setdata.twocodetruck, setdata.twopcodetruck);
    }
  }

  // บันทึกข้อมูลรถคีบ
  SaveNewKeep() {
    let data = (this.AddKeepdata.value);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/insert_Car_keep?Owncode_keep='" + data.onefmcode + "'" // โควต้่เจ้าของระ
      + "&Fmname='" + data.onefmname + "'" // ชื่อเจ้าของรถ
      + "&ownTel='-'"
      + "&Groupcode='" + data.twogroupcode + "'" // กลุ่ม
      + "&Supzone='" + data.threezonecode + "'" // โซน
      + "&name_keeper='" + data.fourdrivername + "'" // ชื่อคนขับ
      + "&tel_keeper='" + data.fivedriverphone + "'" // เบอร์โทรคนขับ
      + "&TruckBand='-'" // ไม่ต้องใส่
      + "&TruckModel='-'"  // ไม่ต้องใส่
      + "&dataOK=1";  // ไม่ต้องใส่

    if (data.onefmcode == '') { alert("กรุณาระบุโควค้า"); }
    else if (data.twogroupcode == '') { alert("กรุณาระบุกลุ่ม"); }
    else if (data.threezonecode == '') { alert("กรุณาระบุ โซน"); }
    else if (data.fourdrivername == '') { alert("กรุณาระบุ ชื่อคนขับ"); }
    else if (data.fivedriverphone == '') { alert("กรุณาระบุ เบอร์โทรคนขับ"); }
    else {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("บันทึกรายการเรียบร้อย ^^");
          this.AddKeepdata.reset();
          this.LoadAllKeep();
          this.enable = false;
        }
        else {
          alert(" ! !ล้มเหลว ไม่สามารถบันทึกรายการได้! !");
        }
      }).catch(err => { throw (err) });
    }
  }

  // ตรวจสอบทะเบียนรถ
  checkdata: any;
  listregtruc: any;
  CheckBoardTruck() {
    let code = (this.AddTruckdata.get('onetruckboardno').value).trim();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/ck_REGTRUCK?REGTRUCK=" + code;
    axios.get(url).then(res => {
      let data = res.data.recordset;
      this.listregtruc = data;
      if (data.length == 0) {
        //alert('สามารถใช้ทะเบียนนี้ได้');
        this.checkdata = 0;
      }
      else {
        alert('มีทะเบียนนี้แล้ว:' + data[0].REGTRUCK + ', ชื่อ:' + data[0].FMNAME + ', โซน:' + data[0].SUPZONE);
        this.checkdata = 1;
        this.AddTruckdata.get('onetruckboardno').setValue('');
      }
    }
    ).catch(err => { throw err })
  }

  // ข้อมูลชาวไร่ Auto 
  LoadFarmerbycode() {
    var text = ((<HTMLInputElement>document.getElementById("codefm")).value);
    if (text == '') { }
    else {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/farmer_basicByfmcode?text_fm=" + text;
      axios.get(url)
        .then(res => {
          let data = res.data.recordset;
          this.EditTruckdata.get('twopeditcodetruck').setValue(data[0].fmname);
          this.AddKeepdata.get('onefmname').setValue(data[0].fmname);
          this.EditKeepdata.get('oneeditfmname').setValue(data[0].fmname);
        })
        .catch(err => { throw (err); })
    }
  }

  // โหลดข้อมูล EditKeep
  LoadFarmerbycode2() {
    var text = this.EditKeepdata.get('oneeditfmcode').value;
    if (text == '') { }
    else {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/farmer_basicByfmcode?text_fm=" + text;
      axios.get(url)
        .then(res => {
          let data = res.data.recordset;
          this.EditKeepdata.get('oneeditfmname').setValue(data[0].fmname);
        })
        .catch(err => { throw (err); })
    }
  }

  editing = [false, false];
  // อัพเดทข้อมูลรถบรรทุก
  UpdateDataTruck(TRUCK: any) {
    let setdata = TRUCK;
    //setdata = this.EditTruckdata.value;
    // console.log(setdata.threeeditgroupcode.slice(0,6));
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_truckBRR_w?REGTRUCK=%27" + setdata.REGTRUCK + "%27"
      + "&TRUCK_NO=%27" + setdata.TRUCK_NO + "%27"
      + "&OWNCODE=%27" + setdata.OWNCODE + "%27"
      + "&FMNAME=%27" + setdata.FMname + "%27"
      + "&GROUPCODE=%27" + setdata.GROUPCODE + "%27"
      + "&SUPZONE=%27" + setdata.SUPZONE + "%27"
      + "&TRUCK_TYPE=%27" + setdata.TRUCK_TYPE + "%27"
      //+ "&gps='" + setdata.seveneditgps + "%27"
      //+ "&smartPhone='" + setdata.sixeditsmartphone + "%27"
      + "&Lastupdate=getdate()";
    console.log(url);
    if (confirm("[ต้องการ อัพเดต ข้อมูล] ?" + setdata.TRUCK_NO)) {
      axios.post(url).then(res => {
        this.editing[0] = false;
        if (res.data.rowsAffected[0] == 1) {
          alert("อัพเดทรายการเรียบร้อย ^^");
          this.EditTruckdata.reset();
          this.LoadTruckdata();
          this.oneedittruck = null;
        }
        else {
          alert(" ! !ล้มเหลว ไม่สามารถอัพเดทรายการได้! !");
        }
      }).catch(err => { throw (err) });
    }
  }

  // อัพเดทข้อมููลรถคีบ
  UpdateDataKeep(KeepID: any) {
    var data = this.EditKeepdata.value;
    var url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_Car_keep?Owncode_keep=" + data.oneeditfmcode
      + "&Fmname=" + data.oneeditfmname
      + "&ownTel=-"
      + "&Groupcode=" + data.twoeditgroupcode.slice(0, 6)
      + "&Supzone=" + data.threeeditzonecode
      + "&name_keeper=" + data.foureditdrivername
      + "&TruckBand=-"
      + "&TruckModel=-"
      + "&tel_keeper=" + data.fiveeditdriverphone
      + "&Keep_no=" + KeepID;
    console.log(url);
    axios.post(url).then(res => {
      if (res.data.rowsAffected[0] == 1) {
        alert("อัพเดทรายการเรียบร้อย ^^");
        this.EditKeepdata.reset();
        this.LoadAllKeep();
      }
      else {
        alert(" ! !ล้มเหลว ไม่สามารถอัพเดทรายการได้! !");
      }
    }).catch(err => { throw (err) });
  }

  // ยกเลิกรถบรรทุก 
  CancleTruck(TRUCK_NO) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_truckBRR_w?TRUCK_NO='" + TRUCK_NO + "'&TRUCK_TYPE='X'"
    if (confirm("ต้องการยกเลิกข้อมูล ?") == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("ยกเลิกรายการเรียบร้อย ^^");
          this.LoadTruckdata();
        }
        else {
          alert(" ! !ล้มเหลว ยกเลิกรายการเรียบร้อย! !");
        }
      }).catch(err => { throw (err) });
    } else { }
  }

  // ยกเลิกรถคีบ
  CancleKeep(KeepID: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/canceled_Car_keep?Keep_no=" + KeepID;
    if (confirm("ต้องการยกเลิกข้อมูล ?") == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("ยกเลิกรายการเรียบร้อย ^^");
          this.LoadAllKeep();
        }
        else {
          alert(" ! !ล้มเหลว ยกเลิกรายการเรียบร้อย! !");
        }
      }).catch(err => { throw (err) });
    } else { }
  }

  // ข้อมูลรถที่จะแก้ไข
  oneedittruck: any;
  onetruck: any;
  onetruck2: any;
  OnetoEdit(TRUCK: any) {
    console.log('TRUCK_NO_s', TRUCK)
    //this.editing[0] = true;
    this.oneedittruck = null;
    this.onetruck = TRUCK;
    this.onetruck2 = TRUCK;

    /*this.oneedittruck = this.alltruck.filter((el: any) => el.TRUCK_NO === TRUCK_NO);
    this.EditTruckdata.get('oneedittruckboardno').setValue(this.oneedittruck[0].REGTRUCK.toString());
    this.EditTruckdata.get('twoeditcodetruck').setValue(this.oneedittruck[0].OWNCODE.toString());
    this.EditTruckdata.get('twopeditcodetruck').setValue(this.oneedittruck[0].FMname.toString());
    this.EditTruckdata.get('threeeditgroupcode').setValue(this.oneedittruck[0].GROUPCODE.toString());
    this.EditTruckdata.get('foureditzonecode').setValue(this.oneedittruck[0].SUPZONE.toString());
    this.EditTruckdata.get('fiveedittrucktype').setValue(this.oneedittruck[0].TRUCK_TYPE.toString());
    this.EditTruckdata.get('sixeditsmartphone').setValue(this.oneedittruck[0].smartPhone.toString());
    this.EditTruckdata.get('seveneditgps').setValue(this.oneedittruck[0].gps.toString());*/
  }

  // ข้อมูลรถคีบที่จะแก้ไข
  onekeepdata: any;
  OneKeepEdit(id: any) {
    this.onekeepdata = this.keepcarall.filter(el => el.Keep_no == id);
    this.EditKeepdata.get('oneeditfmcode').setValue(this.onekeepdata[0].Owncode_keep.toString());
    this.EditKeepdata.get('oneeditfmname').setValue(this.onekeepdata[0].Fmname.toString());
    this.EditKeepdata.get('twoeditgroupcode').setValue(this.onekeepdata[0].Groupcode.toString());
    this.EditKeepdata.get('threeeditzonecode').setValue(this.onekeepdata[0].Supzone.toString());
    this.EditKeepdata.get('foureditdrivername').setValue(this.onekeepdata[0].name_keeper);
    this.EditKeepdata.get('fiveeditdriverphone').setValue(this.onekeepdata[0].tel_keeper);
    console.log(this.onekeepdata);
  }

  // ข้อมูลรถคีบที่จะแก้ไข
  oneretruck: any;
  Oneretruck(id: any) {
    this.oneretruck = this.cancletrucklist.filter(el => el.TRUCK_NO == id);
    console.log(this.oneretruck);
  }

  // เลือกกลุ่ม
  gcode: any;
  editgcodecode: any;
  selectbycode(id: any) {
    if (id == 1) {
      let data = (this.AddTruckdata.get("selectthreegroupcode").value).slice(0, 6);
      this.gcode = data;
      // this.AddTruckdata.get('threegroupcode').setValue(this.gcode);
    }
    else if (id == 2) {
      let data2 = (this.EditTruckdata.get("editthreegroupcode").value).slice(0, 6);
      this.editgcodecode = data2;
    }

    else if (id == 3) {
      let data3 = (this.AddKeepdata.get("selecttwogroupcode").value).slice(0, 6);
      this.AddKeepdata.get('twogroupcode').setValue(data3);
    }
    else if (id == 4) {
      let data3 = (this.EditKeepdata.get("trust").value).slice(0, 6);
      this.EditKeepdata.get('twoeditgroupcode').setValue(data3);
    }
  }
  // สลับปุ่มบันทึกข้อมูล
  enable = true;
  ToggleTrust() {
    this.enable = !this.enable;
  }

  // เปิดใช้งานรถเดิม
  Restoretruck(id: any) {
    let trucktype = this.AddTruckdata.get('fivetrucktype').value;
    if (trucktype == '00' || trucktype == null) {
      alert('เลือกประเภทรถก่อน');
    }
    else {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_truckBRR_w?TRUCK_NO=%27" + id + "%27&TRUCK_TYPE=%27" + trucktype + "%27";
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('อัพเดท รายการรถแล้ว');
        }
        else {
          alert('ไม่สำเร็จกรุณาลองใหม่');
        }

      }
      ).catch(err => { throw err })
    }
  }

  Reset() {
    this.AddKeepdata.reset();
    this.AddTruckdata.reset();
    this.EditTruckdata.reset();
    this.EditTruckdata.reset();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.truckdata = null;
    this.oneedittruck = null;
    this.zone = null;
    this.editgcodecode = null;
    this.gcode = null;
    this.Dataalltruck = null;
    this.onekeepdata = null;
    this.keepcarall = null;
    this.checkdata = null;
    this.listregtruc = null;
    this.cancletrucklist = null;
  }
}
